import { Action } from 'Store/types';
import { ActionTypes, AdminData } from './types';
export const setAdminData = (
  adminData: AdminData,
): Action<ActionTypes, AdminData> => ({
  type: ActionTypes.SET_ADMIN_DATA,
  payload: adminData,
});
